import { FC } from "react";
import { useRoutes } from "react-router-dom";
import LayoutContainer from "../LayoutContainer";
import About from "../Pages/About";
import Home from "../Pages/Home";
import LockScreen from "../Pages/LockScreen";
import NotFound from "../Pages/NotFound";
import Project from "../Pages/Project";
import Project2 from "../Pages/Project2";
import Project3 from "../Pages/Project3";
import Project4 from "../Pages/Project4";
import Project5 from "../Pages/Project5";
import Project6 from "../Pages/Project6";
import Play from "../Pages/Play";
import Project7 from "../Pages/Project7";
import Financial from "../Pages/Financial";
import Zillskill from "../Pages/Zillskill";
import AIBuilt from "../Pages/AIBuilt";


const AppRoutes: FC = () => {
  const Routes = useRoutes([
    {
      path: "/",
      element: <LayoutContainer />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "/pharmagiant",
          element: <Project />,
        },
        {
          path: "/neuma",
          element: <Project2 />,
        },
        {
          path: "/authorcafe",
          element: <Project3 />,
        },
        {
          path: "/databassai",
          element: <Project4 />,
        },
        {
          path: "/creativecoding",
          element: <Project5 />,
        },
        {
          path: "/emotionalchat",
          element: <Project6 />,
        },
        {
          path: "/owly",
          element: <Project7 />,
        },
        {
          path: "/about",
          element: <About />,
        },
        {
          path: "/play",
          element: <Play />,
        },
         {
          path: "/financial",
          element: <Financial />,
        },
        {
          path: "/zillskill",
          element: <Zillskill />,
        },
        {
          path: "/ai-built",
          element: <AIBuilt />,
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);
  return Routes;
};

export default AppRoutes;
